// 브라우저 텔레메트리(로그/트레이스)에 부착할 현재 유저 식별자.
// Sentry.setUser의 대체 — 로그인 시 설정해 모든 OTel 로그/span에 user.id를 남긴다.
// 백엔드(MDCFilter)의 `user.id` span attribute와 같은 key(OTel semantic convention)를
// 사용해 Loki/Tempo에서 프론트-백엔드를 한 유저로 묶는다.
let currentUserId: string | undefined

export function setTelemetryUser(userId: string): void {
  currentUserId = userId
}

export function resetTelemetryUser(): void {
  currentUserId = undefined
}

export function getTelemetryUserId(): string | undefined {
  return currentUserId
}
